import { mapState, mapActions, mapGetters } from "vuex";
export const storeMixin = {
  computed: {
    ...mapState([
      "groups", "selectedGroup",
      "restaurants", "selectedRestaurant",
      "restaurantOrders",
      "restaurantServices", "selectedService",
      "counters", "selectedCounter",
      "sections", "selectedSection",
      "users", "selectedUser",
      "groupProducts",
      "restaurantProducts",
      "assignments",
      "counterOrders",
      "sectionOrders",
      "serviceOrders",
      "reports"
    ]),
    ...mapGetters([
      "sectionServices",
      "draftRestaurantServices",
      "activeRestaurantServices",
      "paidRestaurantServices",
      "closedRestaurantServices",
      "draftSectionServices",
      "activeSectionServices",
      "paidSectionServices",
      "closedSectionServices",
      "serviceOrders",
      "counterOrders",
      "sectionOrders",
      "restaurantReport",
      "sectionReport",
      "counterReport",
      "userAssignments",
      "mySections",
      "myServices",
      "myCounters",
      "myProducts",
      "myOrders",
      "allowedRestaurants",
      "myFeatures"
    ])
  },
  methods: {
    ...mapActions([
      "installApp",
      "bindGroups",
      "selectGroup",
      "bindRestaurants",
      "selectRestaurant",
      "bindUsers",
      // "bindAssignments",
      "selectUser",
      "selectSection",
      "selectCounter",
      "bindCounters",
      "bindSections",
      "bindRestaurantProducts",
      "bindRestaurantOrders",
      "bindRestaurantServices",
      "bindGroupProducts",
      "selectService",
      "bindReports",
      "createDoc",
      "createDocSync",
      "readDocByIdSync",
      "updateDocSync",
      "updateDoc",
      "updateFields",
      "deleteDoc",
      "loadDocs",
      "unbindAll"
    ])
  },
  watch: {
    selectedGroup() {
      this.bindRestaurants();
    },
    selectedRestaurant(newVal) {
      if (newVal) {
        this.bindCounters();
        this.bindSections();
        this.bindRestaurantProducts();
        this.bindRestaurantServices();
        this.bindRestaurantOrders();
        this.bindReports();
      }
    }
  }
}